<template>
	<div class="lifestyle analysis">
		<div class="statistics card">
			<h5>Graph</h5>
				<FoodGraph
					:data="sortedMacronutrientArr"
					food="nutrition"
					>
				</FoodGraph>
		</div>
		<div class="record card">
			<h5>Records</h5>
			<FoodTable :food="food"></FoodTable>
		</div>
	</div>
</template>
<script>
import FoodAnalysis from '.'
import FoodTable from './Table'

import FoodGraph from '../../../graph/type/Food'

export default {
	name: 'lifestyle-card-food-analysis',
	extends: FoodAnalysis,

	components: {
		FoodTable,
		FoodGraph,
	}
}
</script>
<style lang="scss" scoped>
@import "../../component/table/style/analysis.scss";
</style>
